  <form #eventConversion="ngForm">
    <div class="convert-event-container" >
    @for(fieldDictionary of fieldDictionaryList; track fieldDictionary.uiFieldName + '-'+ $index; let i = $index) { 
    <ng-container>
      @if(( (fieldDictionary.fieldName | lowercase) !== 'buydetails' && (fieldDictionary.fieldName | lowercase) !== 'selldetails' && 
      (fieldDictionary.fieldName | lowercase) !== 'aggregatedorders' && (fieldDictionary.fieldName | lowercase) !== 'clientdetails' && 
       (fieldDictionary.fieldName | lowercase) !== 'firmdetails' && (fieldDictionary.fieldName | lowercase) !== 'handlinginstructions'
       && (fieldDictionary.fieldName | lowercase) !== 'firmdesignatedid' ) && (fieldDictionary.fieldName | lowercase) !== 'legdetails'){
      <ng-container>
        <span class="zindex ui-g-12 ui-md-12 ui-lg-4">
          <!--Generic fields -->
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div class="ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg">
              <span><label for="hightlightKeys" [ngClass]="hightlightKeys.indexOf(fieldDictionary.fieldName | lowercase) >= 0 ? 'color-red' : ' '" >
                {{fieldDictionary.uiFieldName}}</label><b>
                  @if(fieldDictionary.required){
                  <sup class="color-red">*</sup>
                  }</b> </span> 

          </div>
            <div
              class="ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg">
              @if((fieldDictionary?.uiDataType | lowercase) == 'choice'){
              <ng-container>
                <p-select  [name]="fieldDictionary.fieldName +'choice'" [id]="fieldDictionary.fieldName+'choice'"  
                [readonly]="fieldDictionary?.fieldName =='type'" [options]="fieldDictionary.choiceDetails"
                  [(ngModel)]="fieldDictionary.jsonValue" appendTo="body" [style]="{'text-transform': 'capitalize','width':'100%'}"
                  placeholder="Select Value" filter="true" [required]="fieldDictionary.required" [showClear]="true">
                  <ng-template let-filterCols let-row pTemplate="item">
                    <div class="ui-helper-clearfix" style="text-transform:capitalize">
                      <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                       [id]="filterCols.label">{{filterCols.label}}</div>
                    </div>
                  </ng-template>
                </p-select>
              </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase) === 'int' || (fieldDictionary.uiDataType | lowercase) === 'float' || 
              (fieldDictionary.uiDataType | lowercase) === 'number' || (fieldDictionary.uiDataType | lowercase) === 'bigdecimal'){
                <ng-container>
                  <input type="number" ng-pattern="constantService.NUMERIC_PATTERN" [name]="fieldDictionary.fieldName"
                    [id]="fieldDictionary.fieldName" maxlength="constantService.NUMERIC_MAXLENGTH" [required]="fieldDictionary.required" 
                    placeholder="Enter Value" style="width:100%" pInputText [(ngModel)]="fieldDictionary.jsonValue" 
                    [disabled]="fieldDictionary.disabled"/>
                </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase) === 'boolean'){
                <ng-container>
                  <p-select [name]="fieldDictionary.fieldName +'boolean'" [id]="fieldDictionary.fieldName+'boolean'"
                   [options]="booleanDropDown" [(ngModel)]="fieldDictionary.jsonValue" appendTo="body"
                    [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select Value" filter="true"
                    [required]="fieldDictionary.required">
                    <ng-template let-filterCols let-row pTemplate="item">
                      <div class="ui-helper-clearfix" style="text-transform:capitalize">
                        <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                      </div>
                    </ng-template>
                  </p-select>
                </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase) === 'string' || (fieldDictionary.uiDataType | lowercase) === 'char'){
                <ng-container>
                  @if((fieldDictionary.fieldName | lowercase) !== 'symbol' && (fieldDictionary.fieldName | lowercase) !== 'type'){
                  <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" [ngStyle]="{width:'100%'}"
                    pInputText [required]="fieldDictionary.required" 
                    placeholder="Enter Value" [(ngModel)]="fieldDictionary.jsonValue" [disabled]="fieldDictionary.disabled"/>
                  }
                  @if((fieldDictionary.fieldName | lowercase) === 'symbol' || (fieldDictionary.fieldName | lowercase) === 'type'){
                  <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" [ngStyle]="{width:'100%'}" 
                    pInputText 
                    placeholder="Enter Value" [(ngModel)]="fieldDictionary.jsonValue" [disabled]="fieldDictionary.disabled"/>
                  }
                </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase)==='date'){
                <ng-container>
                  <p-datepicker appendTo="body"
                  [touchUI]="true"
                  [(ngModel)]="fieldDictionary.jsonValue" 
                  [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName"
                  [required]="fieldDictionary.required"
                  [hourFormat]=" '24' "
                  placeholder="Enter Value"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [style]="{'width':'95% !important'}"
                  inputId="icondisplay"
                  [motionOptions]="{ duration: 0 }"/>
                </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase)==='datetime' || (fieldDictionary.uiDataType | lowercase)==='timestamp'){
                <ng-container>
                  <div class="ui-g-12 nopadding ">
                    <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" type="text"
                      placeholder="Enter Value" style="width:100%" pInputText [(ngModel)]="fieldDictionary.jsonValue" />
                  </div>
                </ng-container>
              }
              @else if((fieldDictionary.uiDataType | lowercase)==='choicevalues'){
                <ng-container>
                  <!--Special case-->
                  @if((fieldDictionary.fieldName | lowercase) === 'timeinforce'){
                  <ng-container>
                  @if(fieldDictionary.fieldName === 'timeInForce'){
                  <div class="ui-g-12 ui-md-6 ui-lg-4 quick-view-grid-row-hg">
                    <p-select [name]="fieldDictionary.fieldName +'choicevaluesDropdown'" [id]="fieldDictionary.fieldName+'choicevaluesDropdown'" 
                    [readonly]="false" [options]="fieldDictionary.choiceDetails"
                      [(ngModel)]="timeInForceChoice" appendTo="body" (onChange)="setEditRowValue(i,timeInForceChoice)"
                      [style]="{'text-transform': 'capitalize','width':'100%'}"
                      [placeholder]="timeInForceChoice" filter="true" [required]="fieldDictionary.required"
                      class="timeInForceDropdown">
                      <ng-template let-filterCols let-row let-rowIndex pTemplate="item">
                        <div class="ui-helper-clearfix" style="text-transform:capitalize">
                          <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}
                          </div>
                        </div>
                      </ng-template>
                    </p-select>
                  </div>
                }
                  <div class="ui-g-12 ui-md-6 ui-lg-8 quick-view-grid-row-hg">
                    <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" [required]="fieldDictionary.required" type="text"
                      placeholder="Enter Value" style="width:100%" pInputText [(ngModel)]="timeInForceValue" />
                  </div>
                  </ng-container>
                  }
                  <!--End of special case-->
                </ng-container>
              }
            </div>
          </div>
        </span>
      </ng-container>
      }
    </ng-container>
    }
    @for(fieldDictionary of fieldDictionaryList; track fieldDictionary.fieldName + '-'+ $index; let i = $index) { 
    <ng-container>
      @if(!( (fieldDictionary.fieldName | lowercase) !== 'buydetails' && (fieldDictionary.fieldName | lowercase) !== 'selldetails' && (fieldDictionary.fieldName | lowercase) !== 'aggregatedorders'
      && (fieldDictionary.fieldName | lowercase) !== 'clientdetails' &&  (fieldDictionary.fieldName | lowercase) !== 'firmdetails' && (fieldDictionary.fieldName | lowercase) !== 'handlinginstructions'
      && (fieldDictionary.fieldName | lowercase) !== 'firmdesignatedid' && (fieldDictionary.fieldName | lowercase) !== 'legdetails' )){
      <ng-container>
        <span class="zindex ui-g-12 ui-md-12 ui-lg-12">
                     <!-- firmDesignatedID Details -->
                      @if(fieldDictionary.fieldName=='firmDesignatedID'){
                     <div class="nopadding dialog-normal-form-field">
                      <div class="col-md-5 nopadding ">
                         <div class="row ">
                           <div class="col-md-3 dialog-form-field"><label for="givenName">GivenName</label></div>
                             <div class="col-md-2"><p-toggleswitch [name]="fieldDictionary.fieldName+'_Checked'" [id]="fieldDictionary.fieldName+'_Checked'" [(ngModel)]="checked" styleClass="inputSwitch"></p-toggleswitch></div>
                             <div class="col-md-7"> <input [disabled]="!checked" placeholder="Enter givenName" [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" [(ngModel)]="givenNameForFDID" >
                               <p-button type="button" icon="fa fa-check" [disabled]="!checked" (click)="getFDID(i)"></p-button></div>
                          </div> 
                      </div>
                      <div class="col-md-7 nopadding">
                        <div class="row">
                           <div class="col-md-4 dialog-normal-form-field">                           
                            <span> <label for="hightlightKeys" [ngClass]="hightlightKeys.indexOf(fieldDictionary.fieldName | lowercase) >= 0 ? 'color-red' : ' '">
                            Firm Designated ID</label></span> <b>
                              @if(fieldDictionary.required){
                              <sup class="color-red">*</sup>}</b>                          
                          </div>
                          <div class="col-md-2"><p-toggleswitch [name]="fieldDictionary.fieldName+'_Checked1'" [id]="fieldDictionary.fieldName+'_Checked1'" [(ngModel)]="checkedFdid" styleClass="inputSwitch"></p-toggleswitch></div>
                          
                           <div class="col-md-5"> <input [required]="fieldDictionary.required" placeholder="Enter Firm Designated ID" [name]="fieldDictionary.fieldName+'Value'" [(ngModel)]="fieldDictionary.jsonValue" style="width: 100%"></div>
                        </div> 
                      </div>
                     </div>
                      }
          
          <!--Special cases-->
          @if((fieldDictionary.fieldName| lowercase) === 'aggregatedorders'){
         <div class="ui-grid-col-12 horizontal-scroll">
            <mat-divider></mat-divider>

            <span class="dialog-section-header"><label for="highlightkeys" [ngClass]="hightlightKeys.indexOf(fieldDictionary.fieldName | lowercase) >= 0 ? 'color-red' : ' '"><b>Aggregated Order Details</b></label></span>
            
            <p-table [columns]="eventConversionService.aggoOrdersCols" [value]="fieldDictionary.jsonValue" #dt1 class="cell-editor-table">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for(col of columns; track col.header + '-'+ $index) { 
                  <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    {{col.header}}
                  </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-aggoOrdersRowData let-ri="rowIndex" let-columns="columns">
                <tr [pSelectableRow]="aggoOrdersRowData">
                  @for(col of columns; track col.field + '-'+ $index) { 
                  <td [ngClass]="(col?.display | lowercase) === 'false' ? 'notdisplay':'' ">
                    @if((col.uiDataType | lowercase) !== 'int' && (col.uiDataType | lowercase) !=='float'){
                    <span>
                      {{aggoOrdersRowData[col.field]}}
                    </span>
                    }
                    @if((col.uiDataType | lowercase) === 'int' || (col.uiDataType | lowercase) === 'float'){
                    <span style="float:right;">
                      {{aggoOrdersRowData[col.field]}}
                    </span>
                    }
                  </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
          }
          @if(fieldDictionary.fieldName=='handlingInstructions'){
          <div class="ui-grid-col-8 container nopadding dialog-normal-form-field">
            <mat-divider></mat-divider>
            <p-table id = "eventHandlingInstructionTable" [columns]="eventConversionService.handlingInstructionCols" [value]="handlingInstructionData" #dt2 class="cell-editor-table">
              <ng-template pTemplate="caption">
                <div class="row">
                    <div class="col-md-4" style="text-align:left">
                        <span class="dialog-section-header"><b>Handling Instructions</b></span>
                      </div>
                      <div class="col-md-4" style="text-align:left">
                        <p-multiSelect [name]="fieldDictionary.fieldName +'multiselect'" [id]="fieldDictionary.fieldName+'multiselect'" appendTo="body" 
                        [options]="this.userService.handlingInstructions" [(ngModel)]="eventConversionService.handlingInstructionCols" optionLabel="header"
                         selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}"  placeholder="Choose Columns" class="cat-exp-select"></p-multiSelect>
                    </div>
                </div>     
            </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for(col of columns; track col.header + '-'+ $index) { 
                  <th id="colHeader">
                    {{col.header}}
                  </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-handlingInstructionData let-columns="columns">
                <tr >
                  @for(col of columns; track col.field + '-'+ $index) { 
                  <td style="width:10" pEditableColumn>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input  [name]="fieldDictionary.fieldName +'inp'" [id]="fieldDictionary.fieldName+'inp'"  
                        [(ngModel)]="handlingInstructionData[col.field]">
                      </ng-template>
                      <ng-template pTemplate="output">
                        <span >
                          {{handlingInstructionData[col.field]}}
                        </span>
                      </ng-template>
                  </p-cellEditor>
                  
                  </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
          }
          
          <!-- TDET Grid -->
           @if(( (fieldDictionary.fieldName | lowercase) === 'buydetails' || (fieldDictionary.fieldName | lowercase) === 'selldetails' ||
           (fieldDictionary.fieldName | lowercase) === 'clientdetails' || (fieldDictionary.fieldName | lowercase) === 'firmdetails') || (fieldDictionary.fieldName | lowercase) === 'legdetails'){
          <div class="ui-grid-col-12 horizontal-scroll">
            <mat-divider></mat-divider>
            <span class="dialog-section-header"><b>{{(fieldDictionary.fieldName | lowercase) === 'buydetails' ? 'Buy Details': (fieldDictionary.fieldName | lowercase) === 'selldetails' ? 'Sell Details' : (fieldDictionary.fieldName | lowercase) === 'clientdetails' ? 'Client Details': (fieldDictionary.fieldName | lowercase) =='firmdetails' ? 'Firm Details': (fieldDictionary.fieldName | lowercase) =='legdetails' ? 'Leg Details': ''}}</b></span>
            <p-table resizableColumns=false 
              [columns]="eventConversionService.tdetCols" [value]="fieldDictionary.jsonValue" #dt21 class="cell-editor-table">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for(col of columns; track col.header + '-'+ $index) { 
                  <th id="columnHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    {{col.header}}
                  </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-tradeSideRowData let-columns="columns">
                <tr [pSelectableRow]="tradeSideRowData">
                  @for(col of columns; track col.field + '-'+ $index) { 
                  <td [style]="(fieldDictionary.fieldName | lowercase)==='side' ? 'min-width: 160px !important' : 'min-width: 30px  !important'" pEditableColumn
                  [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                      <input [name]="col.header +'inp'" [id]="col.header+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                      }
                      <!-- set int  -->
                       @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                      <input style="float:right;" [name]="col.header +'inp'" [id]="col.header+'inp'"
                        [(ngModel)]="tradeSideRowData[col.field]">
                       }
                    </ng-template>
                    <ng-template pTemplate="output">
                      @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                      <span>
                        {{tradeSideRowData[col.field]}}
                      </span>
                      }
                      <!-- set int  -->
                       @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                      <span style="float:right;">
                        {{tradeSideRowData[col.field]}}
                      </span>
                      }
                    </ng-template>
                </p-cellEditor>
                  
                  </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
          }
       
         <!--Special cases-->
        </span>
      </ng-container>
      }
    </ng-container>
    }
    <div class="ui-grid-col-12">
        <button pButton type="button" [disabled]="eventConversion.invalid" label="Save"
        class="ui-button-info ui-grid-col-1 btn-style pull-right" (click)="onSave()"></button>
      <button pButton type="button" label="Close" class="ui-button-info ui-grid-col-1 btn-style pull-right"
        (click)="closeDialog.emit(false)"></button>
    </div>
  </div>
</form>